const dedupeIds = (ids = []) => [...new Set(ids.filter(Boolean))];

const padSlots = (ids = [], size = 0) => {
  const padded = [...ids];
  while (padded.length < size) padded.push(null);
  return padded.slice(0, size);
};

export const getLineupMemberStatus = (lineup, wrestlerId) => {
  if (!wrestlerId) return null;
  if (lineup?.champion === wrestlerId) return 'Main_Eventer';
  if ((lineup?.inRing || []).includes(wrestlerId)) return 'In_Ring';
  if ((lineup?.backstage || []).includes(wrestlerId)) return 'Backstage';
  return null;
};

export const applyBulkLineupAction = ({
  lineup,
  selectedIds = [],
  targetStatus,
  maxRing = 0,
  maxBackstage = 0,
}) => {
  const ids = dedupeIds(selectedIds);
  if (ids.length === 0) {
    return { lineup, error: 'Seleziona almeno un wrestler.' };
  }

  const currentRing = dedupeIds(lineup?.inRing || []);
  const currentBackstage = dedupeIds(lineup?.backstage || []);
  let nextChampion = lineup?.champion || null;
  let nextAssignedAt = lineup?.mainEventerAssignedAt || null;
  let nextExpiresAt = lineup?.mainEventerExpiresAt || null;

  const filteredRing = currentRing.filter((id) => !ids.includes(id));
  const filteredBackstage = currentBackstage.filter((id) => !ids.includes(id));

  if (ids.includes(nextChampion)) {
    nextChampion = null;
    nextAssignedAt = null;
    nextExpiresAt = null;
  }

  if (targetStatus === 'In_Ring') {
    const availableSlots = maxRing - filteredRing.length;
    if (ids.length > availableSlots) {
      return {
        lineup,
        error: `Puoi spostare al massimo ${Math.max(0, availableSlots)} wrestler in In-Ring.`,
      };
    }

    const nextRing = [...filteredRing, ...ids];
    return {
      lineup: {
        ...lineup,
        champion: nextChampion,
        mainEventerAssignedAt: nextAssignedAt,
        mainEventerExpiresAt: nextExpiresAt,
        inRing: padSlots(nextRing, maxRing),
        backstage: padSlots(filteredBackstage, maxBackstage),
      },
      error: '',
    };
  }

  if (targetStatus === 'Backstage') {
    const availableSlots = maxBackstage - filteredBackstage.length;
    if (ids.length > availableSlots) {
      return {
        lineup,
        error: `Puoi spostare al massimo ${Math.max(0, availableSlots)} wrestler in Backstage.`,
      };
    }

    const nextBackstage = [...filteredBackstage, ...ids];
    return {
      lineup: {
        ...lineup,
        champion: nextChampion,
        mainEventerAssignedAt: nextAssignedAt,
        mainEventerExpiresAt: nextExpiresAt,
        inRing: padSlots(filteredRing, maxRing),
        backstage: padSlots(nextBackstage, maxBackstage),
      },
      error: '',
    };
  }

  return {
    lineup: {
      ...lineup,
      champion: nextChampion,
      mainEventerAssignedAt: nextAssignedAt,
      mainEventerExpiresAt: nextExpiresAt,
      inRing: padSlots(filteredRing, maxRing),
      backstage: padSlots(filteredBackstage, maxBackstage),
    },
    error: '',
  };
};
